{
    "InboundcallsHeader": "Appels entrants",
    "InboundcallsAvgordervalueLabel": "Valeur moyenne des commandes :",
    "InboundcallsStrikerateLabel": "Strike Rate (Appels par commande) :",
    "OutboundcallsHeader": "Appels sortants",
    "OutboundcallsAvgordervalueLabel": "Valeur moyenne des commandes :",
    "OutboundcallsStrikerateLabel": "Strike Rate (Appels par commande) :",
    "MonetaryCallAssignments_SectionHeader": "Attribution des appels monétaires",
    "MonetaryCallAssignments_SectionPara": "Vous pouvez contrôler la façon dont les statistiques financières\/monétaires des appels sont calculées en attribuant une valeur estimée de la commande de vente ou une valeur monétaire aux appels entrants et sortants réussis, ainsi qu'en spécifiant un taux de réussite des appels comme le nombre d'appels par vente\/commande.",
    "NAME": "MonetaryCallAssignments"
}